import React, { useState, useEffect } from "react";
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import "leaflet-defaulticon-compatibility";
import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css";
import { Alerta } from "./Alerta";

// Asegúrate de establecer el icono por defecto
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png",
  iconUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
  iconSize: [25, 41], // tamaño del ícono (ancho x alto)
  iconAnchor: [12, 41], // punto de anclaje (mitad del ancho, altura completa)
  popupAnchor: [1, -34], // punto del popup relativo al icono
  shadowSize: [41, 41], // tamaño de la sombra
});

// Componente para centrar el mapa y hacer zoom
const MapSearchCenter = ({ latLng, zoom }) => {
  const map = useMap();
  useEffect(() => {
    if (latLng) {
      map.setView([latLng.lat, latLng.lng], zoom); // Centra el mapa y hace zoom
    }
  }, [latLng, zoom, map]);

  return null;
};

const MapaCoordenadas = ({ onLocationSelect, initialPosition, isEditable = true }) => {
  const [position, setPosition] = useState(null);
  const [address, setAddress] = useState(""); // Estado para la dirección
  const [address2, setAddress2] = useState(""); 
  const [isLoading, setIsLoading] = useState(false); // Estado para el loader

  // Actualizar la posición inicial si se proporciona
  useEffect(() => {
    if (initialPosition) {
      const [lat, lng, ...addParts] = initialPosition.split(",");
      const add = addParts.join(",").trim(); 
      setPosition({ lat, lng });
     
      setAddress2(add)
    }
  }, [initialPosition]);

  // Componente que maneja los eventos de click en el mapa, solo si es editable
  const LocationMarker = () => {
    const map = useMap(); // Obtener el mapa
    useMapEvents({
      click(e) {
        if (isEditable) {
          setPosition(e.latlng); // Actualizamos la posición en el estado si es editable
          onLocationSelect({latlng:e.latlng,address:address}); // Llamamos a la función pasada como prop con las coordenadas
          map.setView(e.latlng, 17); // Establecer el zoom cuando se hace click
        }
      },
    });

    return position === null ? null : <Marker position={position}></Marker>;
  };

  // Función para buscar la dirección usando Nominatim
  const handleSearch = async () => {
    if (address.trim() === "") return;

    setIsLoading(true);
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}`
      );
      const data = await response.json();
      if (data.length > 0) {
        const { lat, lon } = data[0]; // Usamos la primera coincidencia
        const latLng = { lat: parseFloat(lat), lng: parseFloat(lon)  };
        setPosition(latLng); // Actualizamos la posición en el mapa
        onLocationSelect({latlng:latLng,address:address}); // Llamamos a la función pasada como prop con las coordenadas
      } else {
        alert("Dirección no encontrada");
      }
    } catch (error) {
      alert("Error al buscar la dirección");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      {isEditable && (
        <>
          <Alerta tipo="info" titulo="Información" texto="Ingrese la dirección a buscar o simplemente haga click en el mapa para posicionar el pin en la ubicación deseada" />
          <div style={{ marginBottom: "10px" }}>
            <input
              type="text"
              placeholder="Buscar dirección, ej: avenida grecia 123, peñalolén"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              style={{ width: "500px", padding: "5px" }}
             
            />
            <button onClick={handleSearch} className="btn btn-primary btn-sm ms-3" disabled={isLoading}>
              {isLoading ? "Buscando..." : "Buscar"}
            </button>
          </div>
        </>
      )}
      <h5>{address2 != "" ? `Dirección ingresada: ${address2}`: ""}</h5>
      <MapContainer
        center={position || [-33.4879, -70.5351]} // Coordenadas iniciales (Santiago, Chile)
        zoom={13}
        style={{ height: "400px", width: "100%" }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        <LocationMarker />
        {position && <MapSearchCenter latLng={position} zoom={17} />} {/* Centrar el mapa según la posición y hacer zoom */} 
      </MapContainer>
    </div>
  );
};

export default MapaCoordenadas;